import { render, staticRenderFns } from "./userPanel.vue?vue&type=template&id=0230dfc2&scoped=true&"
import script from "./userPanel.vue?vue&type=script&lang=js&"
export * from "./userPanel.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=0230dfc2&prod&lang=scss&scoped=true&"
import style1 from "./userPanel.vue?vue&type=style&index=1&id=0230dfc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230dfc2",
  null
  
)

export default component.exports